import * as React from 'react';
import { FieldProps } from '../metadataFormField';
import { FieldGroup } from '../FieldGroup/fieldGroup';
import { getFieldValue } from '../../../utils';
import { ReviewerCardList } from '../ReviewerCardList/reviewerCardList';
import { ReferenceSearch } from '../../ReferenceSearch/referenceSearch';
import { NodeType } from '../../../enums/NodeType';
import { useSelector } from '../../../utils/useSelector';

export const PeerReviewerField = (props: FieldProps) => {
  const { field, data, disabled, updater } = props;
  const { updateField, update } = updater;
  const getAPI = useSelector(s => s.app?.elFn?.getAPI);
  const isMyItemsView = useSelector(s => s.view?.selected?.isMyItemsView);
  const value = getFieldValue(field, data);
  const [isLoading, setIsLoading] = React.useState(false);
  const shouldMask = !!isMyItemsView;

  const api = React.useMemo(() => {
    return getAPI();
  }, []);

  const handleRemove = async (index: number) => {
    if (isLoading) return;
    const previousValue = JSON.parse(JSON.stringify(value));
    try {
      setIsLoading(true);
      updateField(
        field,
        value.filter((_, i) => i !== index)
      );
      await update();
    } catch (e) {
      console.error(
        'An unexpected error occurred while removing a peer reviewer',
        e
      );
      updateField(field, previousValue);
    } finally {
      setIsLoading(false);
    }
  };

  const handleAdd = (values: any[]) => {
    const existing = value || [];
    const newItems = values.filter(
      v => !existing.some(e => e.props.refId === v.props.refId)
    );
    updateField(field, [...existing, ...newItems]);
  };

  const reviewerCards = (
    <ReviewerCardList
      reviewers={value}
      disabled={disabled}
      isLoading={isLoading}
      onRemove={handleRemove}
    />
  );

  return (
    <FieldGroup
      {...props}
      value={value?.length ? reviewerCards : null}
      disabled={disabled}
    >
      <div>
        {!disabled && (
          <ReferenceSearch
            onChange={handleAdd}
            api={api}
            seeOptions={null}
            onBlur={update}
            nodeType={NodeType.Employee}
            multiple={field.multiValue}
            maxResults={50}
            minLength={0}
            selected={[]}
            includeIds={null}
            getClassName={() => (shouldMask ? 'fs-mask' : null)}
            shouldMask={shouldMask}
            schemaField={field}
            excludeRecords={[
              ...(data?.props?.mandatoryReviewer || []),
              ...(data?.props?.additionalMandatoryReviewers || [])
            ]}
          />
        )}
        {reviewerCards}
      </div>
    </FieldGroup>
  );
};
